import { useAPI } from 'hooks/api/useAPI';

import { useApplication } from './useApplication';

export function useCurrentApplication() {
  const { applicationID } = useAPI();
  return useApplication(applicationID!, { enabled: Boolean(applicationID) });
}
